import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/Apoteket.svg'
import _imports_1 from '@/assets/icons/EditGreen.svg'


const _hoisted_1 = { class: "sidebar__container" }
const _hoisted_2 = { class: "sidebar__container-menu-head" }
const _hoisted_3 = { class: "pharmacy-name" }
const _hoisted_4 = { class: "head-block-edit" }
const _hoisted_5 = { class: "sidebar__container-menu-nav" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "link-userGuide",
  href: "https://remomedi.com/apoteket/bruksanvisningar/",
  target: "_blank"
}
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Logout = _resolveComponent("Logout")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", { showSideBar: _ctx.showSideBar }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "head-img",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToPickupBox && _ctx.goToPickupBox(...args)))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Apoteket"
          }, null, -1)
        ]))]),
        _createElementVNode("div", {
          class: "head-block",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToEditPharmacy && _ctx.goToEditPharmacy(...args)))
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.pharmacy?.name), 1),
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("img", {
              src: _imports_1,
              alt: "Edit"
            }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('edit')), 1)
          ])
        ])
      ]),
      _createElementVNode("nav", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routesConfig, (el) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            class: _normalizeClass({
            'router-link': true,
            'router-link-none': _ctx.showElementsSideBar(el.translation)
          }),
            key: el.name,
            to: { name: el.name },
            onClick: ($event: any) => (_ctx.goTo(el.name))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: require(`@/assets/icons/${el.name}.svg`),
                alt: ""
              }, null, 8, _hoisted_6),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${el.translation}`)), 1)
            ]),
            _: 2
          }, 1032, ["class", "to", "onClick"]))
        }), 128)),
        _createElementVNode("a", _hoisted_7, [
          _createElementVNode("img", {
            src: require(`@/assets/icons/UserGuide.svg`),
            alt: ""
          }, null, 8, _hoisted_8),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('userGuide')), 1)
        ])
      ]),
      _createVNode(_component_Logout)
    ])
  ], 2))
}